import { CommonPost } from '../../utils/CommonFetch'; 

export default {
    login
};

async function login(data) {
    let body = {
        username: data.username,
        password: data.password
    }

    const response = await CommonPost('/api/Auth/login', null, body); 
    return response;
}